import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLeaderboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"leaderboard, winner, stats, graph"} maskId="square-filled-radius-0-stroke-1-IconLeaderboard"><path d="M8.5 6V18H15.5V6H8.5Z" fill="currentColor"/><path d="M0.5 8.5V18H7V8.5H0.5Z" fill="currentColor"/><path d="M17 10V18H23.5V10H17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLeaderboard;
